import PropTypes from 'prop-types';

export default {
  addressId: PropTypes.string,
  legacyId: PropTypes.string,
  addressee: PropTypes.string,
  companyName: PropTypes.string,
  nameNumber: PropTypes.string,
  streetName: PropTypes.string,
  addressLine2: PropTypes.string,
  townCity: PropTypes.string,
  county: PropTypes.string,
  postCode: PropTypes.string,
  countryName: PropTypes.string,
  countryCode: PropTypes.string,
  contactNumber: PropTypes.string,
};
